import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { TextField, Button, Box, Typography, MenuItem, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';

const Register = ({ setAuthHeaders, backEnd}) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    position: 'Agent',
    email: '',
    password: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(backEnd + 'register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.message);
        setDialogOpen(true);
        return;
      }

      const authHeader = response.headers.get('Authorization');
      setAuthHeaders(authHeader);
      navigate('/');
    } catch (error) {
      console.error('Registration failed:', error);
      setErrorMessage('An unexpected error occurred. Please try again later.');
      setDialogOpen(true);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>Регистрация</Typography>
      <form onSubmit={handleRegister}>
        <TextField
          label="Име"
          name="firstName"
          fullWidth
          margin="normal"
          value={formData.firstName}
          onChange={handleChange}
          required
        />
        <TextField
          label="Фамилия"
          name="lastName"
          fullWidth
          margin="normal"
          value={formData.lastName}
          onChange={handleChange}
          required
        />
        <TextField
          label="Длъжност"
          name="position"
          select
          fullWidth
          margin="normal"
          value={formData.position}
          onChange={handleChange}
        >
          <MenuItem value="Agent">Брокер</MenuItem>
          <MenuItem value="Person">Частно лице</MenuItem>
        </TextField>
        <TextField
          label="Мейл"
          name="email"
          fullWidth
          margin="normal"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <TextField
          label="Парола"
          name="password"
          type="password"
          fullWidth
          margin="normal"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
          Регистрирай ме
        </Button>
      </form>

      {/* Dialog for displaying error messages */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <Typography>{errorMessage}</Typography>
          <Box sx={{ mt: 2 }}>
            <Typography>
              <Link to="/login">Вход</Link>
            </Typography>
            <Typography>
              <Link to="/password-reset">Промени парола</Link>
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Register;
